import React from 'react';

interface Props {
  htmlContent: string;
}

const SignatureDownload: React.FC<Props> = ({ htmlContent }) => {
  const handleDownload = () => {
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'signature.html';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button className="btn btn-info mt-3" onClick={handleDownload}>
      Signatur herunterladen
    </button>
  );
};

export default SignatureDownload;